import React, { useCallback, useState } from 'react';
import { Accordion, Header, Column } from '@mattilsynet/mt-ui';
import { IKvitteringData } from '../../ducks/kvittering/types';
import { IVirksomhetItem } from '../../ducks/virksomhet-search/types';
import './style.css';
import { Adresse } from '../../features/adresse';
import { OverordnetOrgnummer } from '../../features/adresse/components/OverordnetOrgnummer';
interface IAdresseAccordionProps {
  orgNr?: string;
  item: IKvitteringData | IVirksomhetItem;
  isDefaultOpen?: boolean;
}
export const AdresseAccordion = ({
  orgNr,
  item,
  isDefaultOpen = false
}: IAdresseAccordionProps) => {
  const [showAdress, setShowAdress] = useState(isDefaultOpen);
  const onToggleAdresseDropdown = useCallback(() => {
    setShowAdress(!showAdress);
  }, [showAdress]);
  let toggleText = 'Vis adresse';
  if (showAdress) {
    toggleText = 'Skjul adresse';
  }
  if (orgNr) {
    toggleText += ' og overordnet org nr';
  }
  return <Accordion className="adresse-accordion" open={showAdress} paddingChildren={[0, 0, 0, 0]} header={<Header as="h3" size="heading3">
          {toggleText}
        </Header>} onClick={onToggleAdresseDropdown} data-sentry-element="Accordion" data-sentry-component="AdresseAccordion" data-sentry-source-file="index.tsx">
      <Column justify="flex-start" align="flex-start" data-sentry-element="Column" data-sentry-source-file="index.tsx">
        <Adresse payload={item} data-sentry-element="Adresse" data-sentry-source-file="index.tsx" />
      </Column>
      &nbsp;
      {orgNr && <OverordnetOrgnummer payload={item} />}
    </Accordion>;
};